// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3D6_2","additionalInfo":"AgreementModal_additionalInfo__2Uigm"};